export default __webpack_public_path__ + "static/media/us.60b5001e.png";